import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import EnvironmentManager from 'Utils/environmentManager';
import EmailVerificationModal from './EmailVerificationModal';
import PhoneNumberVerificationModal from './PhoneNumberVerificationModal';
import { ignoreSmsVerification, ignoreEmailVerification } from 'Store/actions';


const VerificationModal = () => {
  const { data: {
    displaySmsOtpActionSheet,
    displayEmailOtpActionSheet
  } } = useSelector(state => state.auth);

  const NUMBER_ACTIONSHEET_SWITCH_RAW = EnvironmentManager.getMessageText({ key: 'number_actionsheet_switch' }) === 'true';
  const EMAIL_ACTIONSHEET_SWITCH_RAW = EnvironmentManager.getMessageText({ key: 'email_actionsheet_switch' }) === 'true';


  const dispatch = useDispatch();

  useEffect(() => {
    if (!NUMBER_ACTIONSHEET_SWITCH_RAW && displaySmsOtpActionSheet) {
      dispatch(ignoreSmsVerification());
    }
    if (!EMAIL_ACTIONSHEET_SWITCH_RAW && displayEmailOtpActionSheet) {
      dispatch(ignoreEmailVerification());
    }
  }, [displaySmsOtpActionSheet, displayEmailOtpActionSheet, dispatch]);

  if (!NUMBER_ACTIONSHEET_SWITCH_RAW && !EMAIL_ACTIONSHEET_SWITCH_RAW) {
    return null;
  }

  if (!displaySmsOtpActionSheet && !displayEmailOtpActionSheet) {
    return null;
  }

  return <div>
    {  NUMBER_ACTIONSHEET_SWITCH_RAW && <PhoneNumberVerificationModal open={ displaySmsOtpActionSheet } /> }
    {  EMAIL_ACTIONSHEET_SWITCH_RAW && <EmailVerificationModal open={ displayEmailOtpActionSheet } />  }
  </div>;
};

export default VerificationModal;
